const EventBus = window.VueEventBus
import config from './config'
import dates from './dates'
import dynamic from './dynamic'
import formatters from './formatters'
import lang from './lang'
import page from './page'
import toastAlert from './re-toast-alert'
import settings from './settings'
import utils from './utils'
import validations from './validations'

window.toastAlert = toastAlert

export default {
  EventBus,
  config,
  dates,
  dynamic,
  formatters,
  lang,
  page,
  toastAlert,
  settings,
  utils,
  validations,
}
